var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7143 16.3684H4.62321C1.85796 16.3684 0 14.4277 0 11.5395V4.85823C0 1.97003 1.85796 0.0292969 4.62321 0.0292969H7.62794C7.96063 0.0292969 8.23065 0.299312 8.23065 0.63201C8.23065 0.964708 7.96063 1.23472 7.62794 1.23472H4.62321C2.54666 1.23472 1.20543 2.65713 1.20543 4.85823V11.5395C1.20543 13.7406 2.54666 15.163 4.62321 15.163H11.7143C13.7909 15.163 15.1329 13.7406 15.1329 11.5395V8.30254C15.1329 7.96984 15.4029 7.69983 15.7356 7.69983C16.0683 7.69983 16.3383 7.96984 16.3383 8.30254V11.5395C16.3383 14.4277 14.4796 16.3684 11.7143 16.3684Z",
    fill: "#482714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51859 10.791H7.91096C8.21633 10.791 8.50242 10.6728 8.7186 10.4567L14.753 4.42231C15.0005 4.1748 15.1371 3.84531 15.1371 3.49494C15.1371 3.14376 15.0005 2.81347 14.753 2.56595L13.775 1.58795C13.2631 1.07766 12.4305 1.07766 11.9178 1.58795L5.91236 7.59339C5.70423 7.80152 5.58609 8.07797 5.57886 8.37129L5.51859 10.791ZM7.9111 11.9964H4.90075C4.73842 11.9964 4.58252 11.9305 4.46921 11.814C4.3559 11.6983 4.29402 11.5416 4.29804 11.3784L4.37358 8.34155C4.38884 7.73723 4.63234 7.16907 5.05987 6.74074H5.06067L11.0661 0.73531C12.0481 -0.245103 13.6449 -0.245103 14.6269 0.73531L15.6049 1.71331C16.0815 2.18905 16.3435 2.8215 16.3427 3.49493C16.3427 4.16836 16.0807 4.80001 15.6049 5.27494L9.57057 11.3093C9.12778 11.7521 8.53792 11.9964 7.9111 11.9964Z",
    fill: "#482714"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2484 6.36167C14.0941 6.36167 13.9398 6.30301 13.8225 6.18488L10.1532 2.51556C9.9177 2.2801 9.9177 1.89838 10.1532 1.66292C10.3886 1.42746 10.7695 1.42746 11.005 1.66292L14.6743 5.33304C14.9098 5.5685 14.9098 5.94942 14.6743 6.18488C14.557 6.30301 14.4027 6.36167 14.2484 6.36167Z",
    fill: "#482714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.bfada572ff084cd183d2579ce53647a9.svg";
export { ForwardRef as ReactComponent };